import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

if (localStorage.getItem("sp_theme") === "light") {
  document.documentElement.classList.add("light");
}

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// boot flag — the plain-HTML watchdog in index.html shows a readable error
// (instead of a white screen) if the bundle never gets this far (e.g. the old
// Chromium inside UE's WebBrowser widget can't run the build).
window.__NC_BOOTED = true;
